export const site = {
  name: "Mashriqain",
  arabicName: "المشرقين",
  descriptor: "Group of Companies",
  description:
    "Mashriqain Group brings together online and offline businesses under one parent organisation. Explore Tansiq Labs, Tuqneen and Silah, our companies in software, education technology and customer communication.",
  email: "hello@mashriqain.com",
} as const;

export const nav = [
  { to: "/ventures", label: "Companies" },
  { to: "/house", label: "The House" },
  { to: "/brand", label: "Identity" },
  { to: "/contact", label: "Contact" },
] as const;

export interface Principle {
  arabic: string;
  transliteration: string;
  title: string;
  body: string;
}

export const principles: Principle[] = [
  {
    arabic: "إتقان",
    transliteration: "Itqān",
    title: "Mastery",
    body: "Work finished to the last detail, including the details no one will check.",
  },
  {
    arabic: "أمانة",
    transliteration: "Amānah",
    title: "Trust",
    body: "Every system, record and taka placed in our hands is held as a trust, not an asset.",
  },
  {
    arabic: "إحسان",
    transliteration: "Iḥsān",
    title: "Excellence",
    body: "Doing more than is required, because the work deserves it.",
  },
];
